import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, model, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AutoFocusModule } from 'primeng/autofocus';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { ScheduleCourierPickupSubmissionModalData } from '../core';

@Component({
    selector: 'app-pickup-submitted-modal',
    standalone: true,
    imports: [DialogModule, TranslateModule, AutoFocusModule, ButtonModule, NgOptimizedImage],
    templateUrl: './pickup-submitted-modal.component.html',
    styleUrls: ['./pickup-submitted-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PickupSubmittedModalComponent {
    readonly isVisible = model.required<boolean>();
    readonly pickupInfo = input.required<ScheduleCourierPickupSubmissionModalData | null>();

    readonly scheduleAnotherPickup = output();

    closeModal() {
        this.isVisible.set(false);
    }
}
